// extracted by mini-css-extract-plugin
export var drawerPaper = "_1r-0";
export var itemCard = "_1r-1";
export var itemImage = "_1r-2";